// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-style {
  font-family: Arial, sans-serif;
  font-size: 16px;
  padding: 8px;
  border: 0;
  border-radius: 4px;
  background-color: #F7F8FC;
  width: 100%;
  max-width: 300px;
  outline: none;
}

.option-style {
  padding: 8px;
  background-color: #fff;
  color: #333;
  outline: none;
}

.SystemControlPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.SystemControlPage .PageContent {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 56px;
}
.SystemControlPage .PageContent .emptyList {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.SystemControlPage .PageContent .LoaderContainer {
  min-height: 487px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.SystemControlPage .PageContent .CardsContent {
  padding-left: 20px;
  padding-top: 20px;
  background: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 36px;
}
.SystemControlPage .PageContent .FirstControlPanel {
  display: flex;
  gap: 40px;
}
.SystemControlPage .PageContent .SecondControlPanelWrapper {
  display: flex;
  gap: 48px;
}
.SystemControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.1s;
}
.SystemControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover {
  color: rgb(173, 164, 164);
}
.SystemControlPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover svg path {
  transition: 0.1s;
  fill: rgb(173, 164, 164);
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/SystemControlPage/SystemControlPage.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AACF;;AAIA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AADF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAFN;AAKI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAHN;AAMI;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAJN;AAOI;EACE,aAAA;EACA,SAAA;AALN;AAQI;EACE,aAAA;EACA,SAAA;AANN;AAQM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AANR;AAQQ;EACE,yBAAA;AANV;AASY;EACE,gBAAA;EACA,wBAAA;AAPd","sourcesContent":[".select-style {\r\n  font-family: Arial, sans-serif;\r\n  font-size: 16px;\r\n  padding: 8px;\r\n  border: 0;\r\n  border-radius: 4px;\r\n  background-color: #F7F8FC;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  outline: none;\r\n}\r\n\r\n.option-style {\r\n  padding: 8px;\r\n  background-color: #fff;\r\n  color: #333;\r\n  outline: none;\r\n}\r\n\r\n\r\n\r\n.SystemControlPage {\r\n  padding-left: 281px;\r\n  background: #EFF0F4;\r\n  width: 100%;\r\n  height: 100vh;\r\n\r\n\r\n  .PageContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 32px;\r\n    margin-top: 56px;\r\n\r\n    .emptyList {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      gap: 20px;\r\n    }\r\n\r\n    .LoaderContainer {\r\n      min-height: 487px;\r\n      height: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n\r\n    .CardsContent {\r\n      padding-left: 20px;\r\n      padding-top: 20px;\r\n      background: white;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      gap: 36px;\r\n    }\r\n\r\n    .FirstControlPanel {\r\n      display: flex;\r\n      gap: 40px;\r\n    }\r\n\r\n    .SecondControlPanelWrapper {\r\n      display: flex;\r\n      gap: 48px;\r\n\r\n      .SecondControlPanelContent {\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        transition: 0.1s;\r\n\r\n        &:hover {\r\n          color: rgb(173, 164, 164);\r\n\r\n          svg {\r\n            path {\r\n              transition: 0.1s;\r\n              fill: rgb(173, 164, 164);\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select-style": `select-style`,
	"option-style": `option-style`,
	"SystemControlPage": `SystemControlPage`,
	"PageContent": `PageContent`,
	"emptyList": `emptyList`,
	"LoaderContainer": `LoaderContainer`,
	"CardsContent": `CardsContent`,
	"FirstControlPanel": `FirstControlPanel`,
	"SecondControlPanelWrapper": `SecondControlPanelWrapper`,
	"SecondControlPanelContent": `SecondControlPanelContent`
};
export default ___CSS_LOADER_EXPORT___;
